<template>
  <a
    v-if="$props.href"
    v-on="$listeners"
    :href="$props.disabled ? $props.href : null"
    :class="classObj"
  >
    <span class="shared-btn__text">{{ $props.label }}</span>
  </a>
  <button
    v-else
    v-on="$listeners"
    :type="$props.type"
    :disabled="$props.disabled"
    :class="classObj"
  >
    <span class="shared-btn__text">{{ $props.label }}</span>
  </button>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      required: true,
    },
    href: String, // if set, a element is used instead of button
    variant: {
      type: String,
      default: "contained",
      validator: (value) => ["contained", "outlined"].includes(value),
    },
    color: {
      type: String,
      default: "primary",
      validator: (value) => ["primary", "gray"].includes(value),
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: "medium",
      validator: (value) => ["medium", "small"].includes(value),
    },
    type: {
      // only when button element is used
      type: String,
      default: "button",
      validator: (value) => ["button", "submit"].includes(value),
    },
  },
  computed: {
    classObj() {
      const { variant, color, disabled, size } = this.$props;

      return {
        "shared-btn": true,
        "shared-btn_contained_primary":
          variant === "contained" && color === "primary",
        "shared-btn_contained_gray":
          variant === "contained" && color === "gray",
        "shared-btn_outlined_primary":
          variant === "outlined" && color === "primary",
        "shared-btn_outlined_gray": variant === "outlined" && color === "gray",
        "shared-btn_disabled_contained": variant === "contained" && disabled,
        "shared-btn_disabled_outlined": variant === "outlined" && disabled,
        "shared-btn_size_small": size === "small",
        "shared-btn_size_medium": size === "medium",
      };
    },
  },
};
</script>
